import React from 'react'
// components
import { ReduxSwitch } from 'components/FormElements'

const StrategyActionsFields: React.FC = () => {
  return <ReduxSwitch label='Show Title' name='showTitle' />
}

export default StrategyActionsFields
